import { Breadcrumb, Button, Card, Col, Row, Tag, Typography } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { formatDateToOnlyMonthAndYear } from "../../helpers/date";
import useMultiNotification from "../../hooks/useNotification";
import MaleBodyViewer from "../../MaleBodyViewer";
import AssignFormulaToOrderModal from "../../modals/AssignFormulaToOrderModal";
import { singleOrderDetailsApi } from "../../redux-toolkit/slices/ordersSlice";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import AddressIcon from "./../../graphics/svgs/AddressIcon.svg";
import MailIcon from "./../../graphics/svgs/MailIcon.svg";
import PhoneIcon from "./../../graphics/svgs/PhoneIcon.svg";
export default function UserOrderComponent() {
  const [showAssign, setShowAssign] = useState<boolean>(false);

  const generalState = useSelector((state: RootState) => state.general);
  const { singleOrder, reloadApiCount } = useSelector(
    (state: RootState) => state.orders
  );
  const { isShowTableInDesktop } = generalState;
  const { contextHolder, openNotification } = useMultiNotification();
  const dispatch = useAppDispatch();
  const { orderId } = useParams();
  useEffect(() => {
    dispatch(singleOrderDetailsApi(`${orderId}`));
  }, []);
  useEffect(() => {
    if (reloadApiCount > 0) {
      dispatch(singleOrderDetailsApi(`${orderId}`));
    }
  }, [reloadApiCount]);

  const painTriggerObj: { [key: string]: string } = {
    at_rest: "At rest",
    being_active: "Being active",
    both: "resting or being active",
    neither: `Pain or resting don't make it worse`,
  };

  const painDailyImpactObj: { [key: string]: string } = {
    none: "Not at all",
    little_bit: "A little bit",
    moderately: "Moderately",
    quite_bit: "Quite a bit",
    extremely: "Extremely",
  };

  const painManagementTimingObj: { [key: string]: string } = {
    am: "Early Morning",
    afternoon: "Midday/Afternoon",
    evening: "Evening/Night",
    allday: "All day",
    varies: "It varies (please explain)",
  };
  const medicineOftenObj: { [key: string]: string } = {
    once: "Once a day",
    twice: "Twice a day",
    three: "Three times a day",
    as_needed: "As needed",
    asneeded: "As needed",
    multiple: "Multiple times a day",
  };

  const medicineDurationObj: { [key: string]: string } = {
    less_week: "Less than a week",
    less_month: "Less than a month",
    less_5_months: "Less than 5 months",
    less_year: "Less than a year",
    year_plus: "1 year +",
  };
  const painManagementGoalObj: { [key: string]: string } = {
    other: `Other (please specify)`,
    sleep: `To improve my sleep quality`,
    medication: `  To reduce reliance on pain medication`,
    activities: ` To return to physical activities or hobbies (e.g., walking,
                gardening, sports)`,
    dailytasks: ` To be able to perform daily tasks currently limited by my pain
                (e.g., cooking, cleaning)`,
    strength: " To improve my strength and flexibility",
  };

  const getPreviouslyDiagnosed = (medicalHistory: MedicalHistory) => {
    let history = medicalHistory.medicalHistory.filter(
      (item) => item !== "Other"
    );
    for (const item of medicalHistory.others) {
      history.push(`${item.name} - ${item.type}`);
    }
    return history;
  };
  return (
    <>
      {contextHolder}

      {singleOrder && (
        <>
          {showAssign === true && (
            <AssignFormulaToOrderModal
              show={showAssign}
              handleClose={(e) => setShowAssign(false)}
              orderId={singleOrder._id}
              painLocations={singleOrder.painProfile.painLocations}
            />
          )}
          <Card>
            <Row className="mb-10">
              <Col md={18} xl={18} xxl={18} lg={18} sm={24} xs={24}>
                <Breadcrumb>
                  <Breadcrumb.Item>
                    <Link to={`/view-users`}>Users</Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <Link to={`/view-users/profile/hamzaJoshan`}>
                      {singleOrder.user.firstName} {singleOrder.user.lastName}
                    </Link>
                  </Breadcrumb.Item>

                  <Breadcrumb.Item>
                    Order#{singleOrder.processingDetails.orderNumber}
                  </Breadcrumb.Item>
                </Breadcrumb>
              </Col>
              {singleOrder.processingDetails.formulaAssigned === null && (
                <Col md={6} xl={6} xxl={6} lg={6} sm={24} xs={24}>
                  <Button
                    type="primary"
                    onClick={(e) => {
                      if (
                        singleOrder.processingDetails.formulaAssigned !== null
                      ) {
                        return;
                      }
                      setShowAssign(true);
                    }}
                  >
                    {" "}
                    Assign Formula
                  </Button>
                </Col>
              )}
            </Row>

            <Row className="w-100p">
              <Col
                className="mb-10 mt-10"
                lg={5}
                xl={5}
                xxl={5}
                md={24}
                sm={24}
                xs={24}
              >
                <Typography className="dashboard-page-sub-title">
                  {singleOrder.user.firstName} {singleOrder.user.lastName}
                </Typography>
                <Typography className="dashboard-page-sub-title">
                  Order # {singleOrder.processingDetails.orderNumber}
                </Typography>
              </Col>
              <Col
                className="mb-10 mt-10"
                lg={3}
                xl={3}
                xxl={3}
                md={12}
                sm={24}
                xs={24}
              >
                <Typography className="users-table-generic-label">
                  <img src={AddressIcon} /> 100 Twinge Lane apt #290, New York,
                  NY 10001
                </Typography>
              </Col>
              <Col
                className="mb-10 mt-10"
                lg={6}
                xl={6}
                xxl={6}
                md={12}
                sm={24}
                xs={24}
              >
                <Typography className="users-table-generic-label">
                  <img src={PhoneIcon} /> (914) 815-660
                </Typography>{" "}
                <Typography className="users-table-generic-label">
                  <img src={MailIcon} /> {singleOrder.user.email}
                </Typography>{" "}
              </Col>
              <Col
                className="mb-10 mt-10"
                lg={6}
                xl={6}
                xxl={6}
                md={12}
                sm={24}
                xs={24}
              >
                <Typography className="users-table-generic-label">
                  DOB:{singleOrder.demoGraphics.dob}
                </Typography>
                <Typography className="users-table-generic-label">
                  {singleOrder.demoGraphics.weight} lb,{" "}
                  {singleOrder.demoGraphics.heightFeet}’{" "}
                  {singleOrder.demoGraphics.heightInches}”
                </Typography>
                <Typography className="users-table-generic-label">
                  {singleOrder.demoGraphics.gender.toUpperCase()}{" "}
                  {singleOrder.demoGraphics.pregnant && (
                    <strong> - Pregnant</strong>
                  )}
                </Typography>
              </Col>
            </Row>
            <Row className="w-100p">
              <Col span={24} className="display-flex">
                <Typography className="user-profile-allergy-label">
                  <strong>Allergies:</strong>
                </Typography>
                <div>
                  {" "}
                  {singleOrder.demoGraphics.allAllergies.map((item, index) => {
                    return (
                      <span
                        key={Math.random()}
                        className="user-profile-allergy-label"
                      >
                        {item.type} - {item.severity},
                      </span>
                    );
                  })}
                </div>
              </Col>
              <Col span={24} className="mt-10 display-flex">
                <Typography className="user-profile-allergy-label">
                  <strong>Notes to MD: </strong>
                </Typography>

                <Typography className="user-profile-allergy-label">
                  {singleOrder.additionalInfo}
                </Typography>
              </Col>
            </Row>
            <Row className="w-100p mt-10">
              <Col span={24}>
                <Typography className="dashboard-page-sub-title">
                  About Pain:
                </Typography>
              </Col>
              <Col lg={16} xl={16} xxl={16} sm={24} md={24} xs={24}>
                <div className="w-100p">
                  <Typography className="order-page-pain-label">
                    1.
                    {singleOrder.painProfile.painDuration === "acute" ? (
                      <>
                        <strong>Acute</strong> - less than 3 months
                      </>
                    ) : (
                      <>
                        <strong>Chronic</strong> - more than 3 months
                      </>
                    )}
                  </Typography>
                  <Typography className="order-page-pain-label">
                    2. {singleOrder.painFactors.physicalActivity} level of
                    physical activity
                  </Typography>{" "}
                  <Typography className="order-page-pain-label">
                    3.Pain gets worse with{" "}
                    <strong>
                      {singleOrder.painFactors.painWorseDescriptions.join(",")}
                    </strong>
                  </Typography>{" "}
                  <Typography className="order-page-pain-label">
                    4.Associated symptoms include{" "}
                    <strong>
                      {singleOrder.painSymptoms.selectedPainDescriptions.join(
                        ","
                      )}
                    </strong>
                  </Typography>{" "}
                  <Typography className="order-page-pain-label">
                    5.Pain frequency is{" "}
                    <strong> {singleOrder.painSymptoms.painFreq}</strong>
                  </Typography>{" "}
                  <Typography className="order-page-pain-label">
                    6.Worsens when{" "}
                    <strong>
                      {painTriggerObj[singleOrder.painSymptoms.painTrigger] ||
                        "None"}
                    </strong>
                  </Typography>{" "}
                  <Typography className="order-page-pain-label">
                    7.
                    {singleOrder.painSymptoms.showTriggerTextBox === true &&
                      singleOrder.painSymptoms.painTriggerInfo}
                  </Typography>
                  <Typography className="order-page-pain-label">
                    8.
                    {singleOrder.painSymptoms.showPainChangeTextBox === true &&
                      singleOrder.painSymptoms.painChangeInfo}
                  </Typography>
                  <Typography className="order-page-pain-label">
                    9.
                    {singleOrder.painSymptoms.showPainSevereTimeTextBox ===
                      true &&
                      singleOrder.painSymptoms.painSpecificTimeInDayInfo}
                  </Typography>
                  <Typography className="order-page-pain-label">
                    10.
                    {painDailyImpactObj[
                      singleOrder.painSymptoms.painDailyImpact
                    ] || "None"}{" "}
                    interferes with daily activities
                  </Typography>
                  <Typography className="order-page-pain-label">
                    11. Most pain occurs in{" "}
                    <strong>
                      {painManagementTimingObj[
                        singleOrder.painManagement.timing
                      ] || "None"}
                    </strong>{" "}
                  </Typography>
                </div>
                <Typography className="dashboard-page-sub-title mt-10 mb-10">
                  Previously diagnosed with{" "}
                </Typography>
                <div className="w-100p">
                  {getPreviouslyDiagnosed(singleOrder.medicalHistory).map(
                    (item, index) => {
                      return (
                        <Typography
                          key={Math.random()}
                          className="order-page-pain-label"
                        >
                          {index + 1}. {item}
                        </Typography>
                      );
                    }
                  )}
                </div>

                <Typography className="dashboard-page-sub-title mt-10 mb-10">
                  History of surgery, injury, or accident{" "}
                </Typography>
                <div className="w-100p mb-20">
                  {singleOrder.injuryHistory.injuryEntries.map(
                    (item, index) => {
                      return (
                        <Typography
                          key={Math.random()}
                          className="order-page-pain-label"
                        >
                          {index + 1}. {item.type}; {item.name}; {item.details};{" "}
                          {formatDateToOnlyMonthAndYear(item.date)}
                        </Typography>
                      );
                    }
                  )}
                </div>
                <Typography className="dashboard-page-sub-title mt-10 mb-10">
                  Medications:{" "}
                </Typography>
                <Typography className="dashboard-page-sub-title-small  mt-10">
                  Prescription Medicine
                </Typography>
                <div className="w-100p mb-20">
                  {singleOrder.medicineHistory.medicineDetails.map(
                    (item, index) => {
                      return (
                        <Typography
                          key={Math.random()}
                          className="order-page-pain-label"
                        >
                          {index + 1}. {item.drugName} {item.strength},
                          {medicineOftenObj[item.usageFreq] || "None"}
                        </Typography>
                      );
                    }
                  )}
                </div>

                <Typography className="dashboard-page-sub-title-small">
                  Over-the counter Products
                </Typography>
                <div className="w-100p mb-20">
                  {singleOrder.medicineHistory.otcMedicineHistory.map(
                    (item, index) => {
                      return (
                        <Typography
                          key={Math.random()}
                          className="order-page-pain-label"
                        >
                          {index + 1}. {item.drugName} {item.form}{" "}
                          {item.strength},
                          {medicineDurationObj[item.usageFreq] || "None"}
                        </Typography>
                      );
                    }
                  )}
                </div>
                {singleOrder.medicineHistory.medicineDescriptions
                  .filter(
                    (item) =>
                      item !== "Other" &&
                      item !== "Prescription Medicine" &&
                      item !== "Over-the-Counter Products"
                  )
                  .map((item) => {
                    return (
                      <Typography
                        key={Math.random()}
                        className="dashboard-page-sub-title-small "
                      >
                        {item}
                      </Typography>
                    );
                  })}

                <Typography className="dashboard-page-sub-title mt-10 mb-10">
                  Primary goals of pain management include:
                </Typography>
                <Typography className="dashboard-page-sub-title-small ">
                  1.
                  {painManagementGoalObj[singleOrder.painManagement.painGoal] ||
                    "None"}
                </Typography>

                <Typography className="dashboard-page-sub-title mt-10 mb-10">
                  Feedback from other topicals.{" "}
                </Typography>
                <Typography className="dashboard-page-sub-title-small ">
                  1.How do you prefer to apply topical treatments?
                  <strong>
                    {medicineOftenObj[
                      singleOrder.painManagement.applicationFrequency
                    ] || "None"}
                  </strong>
                </Typography>
                {singleOrder.painManagement.usedBefore === "yes" &&
                  singleOrder.painManagement.experience && (
                    <Typography className="dashboard-page-sub-title-small ">
                      2. {singleOrder.painManagement.experience}
                    </Typography>
                  )}
              </Col>
              {/*  */}
              <Col lg={8} xl={8} xxl={8} sm={24} md={24} xs={24}>
                <div className="pain-rating-container-order-details mb-10">
                  <Typography className="dashboard-page-sub-title">
                    Pain Rating : {singleOrder.painProfile.painRating}
                  </Typography>
                </div>
                {singleOrder.injuryHistory.hasOpenWound === "yes" && (
                  <div className="mb-10">
                    <Typography className="user-profile-allergy-label">
                      OPEN SORE or WOUND AT SITE OF PAIN
                    </Typography>
                  </div>
                )}
                <MaleBodyViewer isBodyClickEnable={false} />
                {/* Lets do the rest here. */}
                <div className="mt-30"></div>
                {singleOrder.medicalHistory.medicalHistory.includes(
                  "Arthritis"
                ) && (
                  <Typography className="order-page-pain-label mb-10">
                    <strong>Arthritis:</strong>
                    Indicated swelling or inflammation associated with the pain
                    and specific joints impacted.
                  </Typography>
                )}
                {singleOrder.painSymptoms.selectedPainDescriptions.includes(
                  "Muscle spasms"
                ) && (
                  <Typography className="order-page-pain-label mb-10">
                    <strong>Muscle Spasms:</strong>
                    Indicated interferes with sleep and accompanied by stiffness
                    or weakness.
                  </Typography>
                )}
                <Row className="w-100p">
                  {singleOrder.painProfile.painDescriptions.map((option) => (
                    <Col
                      className="mt-30"
                      key={option}
                      xl={12}
                      xxl={12}
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      style={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      <Tag.CheckableTag
                        checked={true}
                        className="checkable-tag-pain-entry"
                      >
                        {option}
                      </Tag.CheckableTag>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </Card>
        </>
      )}
    </>
  );
}
